<div class="content-header shadow p-3">
    @if(!instance()) {
        <label>
          {{ title() }}
        </label>
    }
    <div class="flex gap-x-2" [ngClass]="{'py-2' : !instance(), 'pt-3 pb-3': instance()}">
      <p-button id="saveButton" *ngIf="!hideSaveButton()" label="Save" size="small" [disabled]="invalid() || !hasPermissionEdit() || (isViewOnly() && id())" (click)="save.emit()" />
      @if(isViewOnly() || !id() || instance()) {
      <p-button id="cancelButton" label="Cancel" styleClass="bg-red-600 hover:bg-red-800 border-red-600" size="small"
      (click)="cancel.emit()" />
      }
      @if(id() && hasPermissionEdit() && !hideViewOnlyButton()) {
        <p-button id="viewOnlyEditButton" [label]="!isViewOnly() ? 'View Only' : 'Edit' " size="small" (click)="toggleEdit.emit()" />
      }
    </div>
  </div>